import React from 'react';
import { TicketGroupData } from '../types';
import { Layers, Pencil, Trash2 } from 'lucide-react';

interface TicketGroupListProps {
  ticketGroups: TicketGroupData[];
  onEditTicketGroup: (ticketGroup: TicketGroupData) => void;
  onDeleteTicketGroup: (ticketGroupId: string) => void;
}

const TicketGroupList: React.FC<TicketGroupListProps> = ({
  ticketGroups,
  onEditTicketGroup,
  onDeleteTicketGroup
}) => {
  console.log('Rendering TicketGroupList with ticketGroups:', ticketGroups);
  if (ticketGroups.length === 0) {
    return (
      <div style={{ padding: "32px 16px", textAlign: "center", borderRadius: 14, background: "rgba(255,255,255,0.02)", border: "1px dashed rgba(255,255,255,0.08)" }}>
        <Layers size={28} color="rgba(255,255,255,0.2)" style={{ margin: "0 auto 8px auto", display: "block" }} />
        <div style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>No ticket groups added yet</div>
        <p style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginTop: 4, marginBottom: 0 }}>Click "Add Ticket Group" to get started.</p>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 16 }}>
      {ticketGroups.map((ticketGroup) => (
        <div
          key={ticketGroup.id}
          style={{
            padding: 16,
            borderRadius: 14,
            background: "rgba(255,255,255,0.03)",
            border: "1px solid rgba(255,255,255,0.07)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 14, flex: 1, minWidth: 200 }}>
            <div style={{
              width: 42, height: 42, borderRadius: 12, flexShrink: 0,
              background: "rgba(168, 85, 247, 0.15)",
              border: "1px solid rgba(168, 85, 247, 0.3)",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <Layers size={18} color="#a855f7" />
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <span style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>
                  {ticketGroup.groupName}
                </span>
                <span style={{
                  fontSize: 9, fontFamily: "monospace", padding: "2px 6px", borderRadius: 4,
                  background: ticketGroup.isSlotRequired ? "rgba(251, 191, 36, 0.15)" : "rgba(255,255,255,0.06)",
                  color: ticketGroup.isSlotRequired ? "#fbbf24" : "rgba(255,255,255,0.45)",
                  textTransform: "uppercase", fontWeight: 600,
                  border: ticketGroup.isSlotRequired ? "1px solid rgba(251, 191, 36, 0.25)" : "none",
                }}>
                  {ticketGroup.isSlotRequired ? 'Slot Required' : 'No Slot'}
                </span>
                <span style={{
                  fontSize: 9, fontFamily: "monospace", padding: "2px 6px", borderRadius: 4,
                  background: ticketGroup.status === "active" ? "rgba(52, 211, 153, 0.15)" : "rgba(255,93,115,0.12)",
                  color: ticketGroup.status === "active" ? "#34d399" : "#FF5D73",
                  textTransform: "uppercase", fontWeight: 600,
                  border: ticketGroup.status === "active" ? "1px solid rgba(52, 211, 153, 0.25)" : "1px solid rgba(255,93,115,0.2)",
                }}>
                  {ticketGroup.status === "active" ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <button
              type="button"
              className="v3-btn-secondary"
              style={{ fontSize: 11, padding: "6px 10px" }}
              onClick={() => onEditTicketGroup(ticketGroup)}
            >
              <Pencil size={12} /> Edit
            </button>
            <button
              type="button"
              style={{
                background: "rgba(255,93,115,0.15)",
                border: "1px solid rgba(255,93,115,0.3)",
                color: "#FF5D73", borderRadius: 8,
                padding: "6px 10px", fontSize: 11, cursor: "pointer",
                display: "flex", alignItems: "center", gap: 4, fontWeight: 600,
              }}
              onClick={() => onDeleteTicketGroup(ticketGroup.id.toString())}
            >
              <Trash2 size={12} /> Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TicketGroupList;